export function formatNumber(number) {
    return number.toLocaleString('en-US');
}

export function formatNumberToPercentage(number) {
    return number.toLocaleString('en-US', {
        style: 'percent'
    });
}